'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = onArrowRight;

var _constants = require('./constants');

var _utils = require('./utils');

/**
 * Determines behavior if the caret is currently outside of an inline, while arrowing to the right
 *
 * @param {Event} event
 * @param {Editor} editor
 * @param {function} next
 * @param {Object} opts
 * @param {Object} state
 * @return {Null | Editor}
 */

function handleArrowRightOutsideInline(event, editor, next, opts, state) {
  var _editor$value = editor.value,
      document = _editor$value.document,
      selection = _editor$value.selection,
      focusText = _editor$value.focusText;

  var isExtending = event.shiftKey;
  var hasStickyBoundaries = opts.hasStickyBoundaries;

  // We are outside of an inline and need to figure out if we are anywhere close to a sticky inline

  var isAtEndOfCurrentTextNode = selection.focus.offset === focusText.text.length;
  var isAtSecondToLastCharacter = selection.focus.offset === focusText.text.length - 1;

  var upcomingNode = document.getNextSibling(selection.focus.path);

  if ((0, _utils.isInlineBanned)(editor, upcomingNode, opts) || !hasStickyBoundaries || isExtending || editor.isVoid(upcomingNode)) return next();

  if (isAtSecondToLastCharacter) {
    return editor.command(_utils.moveToEndOf, focusText, event, state);
  }

  if (isAtEndOfCurrentTextNode) {
    return editor.command(_utils.moveToStartOf, upcomingNode, event, state);
  }
}

/**
 * Determines behavior if the caret is currently inside of an inline, while arrowing to the right
 *
 * @param {Event} event
 * @param {Editor} editor
 * @param {function} next
 * @param {Object} opts
 * @param {Object} state
 * @return {Null | Editor}
 */

function handleArrowRightInsideInline(event, editor, next, opts, state) {
  var _editor$value2 = editor.value,
      document = _editor$value2.document,
      selection = _editor$value2.selection,
      focusInline = _editor$value2.focusInline;

  var isExtending = event.shiftKey;
  var hasStickyBoundaries = opts.hasStickyBoundaries;

  // In normal slate inline world, these two boundaries are the true start/end of an Inline.
  // Since you can never actually move to the start or end of an inline (that's what we are fixing after all!)

  var isAtSecondToLastCharacter = selection.focus.offset === focusInline.text.length - 1;

  // Thanks to this very plugin, it's common to be in this editor.value where you are at the edge of an inline.
  var isAtLastCharacter = selection.focus.offset === focusInline.text.length;

  var inlinePath = document.getPath(focusInline);
  var upcomingNode = document.getNextSibling(inlinePath);

  // We are on an edge on the inside of an inline.  If they don't want sticky boundaries, or if they are extending,
  // then it doesn't stick here.
  if (isAtLastCharacter && upcomingNode && hasStickyBoundaries && !isExtending) {
    return editor.command(_utils.moveToStartOf, upcomingNode, event, state);
  }

  // In this case they are attempting to leave an artifact so we should make sure that
  // Is a smooth process
  if (upcomingNode && focusInline.text === _constants.ZERO_WIDTH_SPACE) {
    return editor.command(_utils.moveToStartOf, upcomingNode, event, state, 1);
  }

  if (isAtSecondToLastCharacter) {
    return editor.command(_utils.moveToEndOf, focusInline, event, state);
  }
  return next();
}

/**
 * Caret Manipulation logic
 *
 * @param {Event} event
 * @param {Editor} editor
 * @param {function} next
 * @param {Object} opts
 * @param {Object} state
 * @return {Null}
 */

function onArrowRight(event, editor, next, opts, state) {
  if (event.ctrlKey) return next();

  // In these cases we are actually inside the inline.
  if (editor.value.focusInline) return handleArrowRightInsideInline(event, editor, next, opts, state);

  return handleArrowRightOutsideInline(event, editor, next, opts, state);
}